import type { PublicApiKey } from '#packages/apilib';
import type { createPlatformApi } from './platformWrapper';

export const PlatformApiKey: PublicApiKey<typeof createPlatformApi> = {
  name: 'PlatformApi',
  public: true,
};
